import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { SelectInput } from 'components/Common/Inputs';
import FileUpload from 'components/Common/FileUpload';
import FormTypeSelect from 'components/Common/FormTypeSelect';
import { ApiService } from 'services';
import { toastr } from 'react-redux-toastr';
import { getStorageSetting } from 'actions';
import FormTypes from 'common/Forms/FormTypes';

class BeneficialOwnerFormsUpload extends Component {
  static propTypes = {
    onFileUploadSuccess: PropTypes.func.isRequired,
    whdStatement: PropTypes.shape({
      owners: PropTypes.arrayOf(PropTypes.shape({}))
    }).isRequired,
    onBeneficiarySelected: PropTypes.func.isRequired,
    onFileDeleteSuccess: PropTypes.func,
    onFileDeleteError: PropTypes.func,
    onFileUploadCancel: PropTypes.func,
    onFileUploadError: PropTypes.func,
    formErrors: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.any)]),
    disableToasters: PropTypes.bool,
    benefForms: PropTypes.arrayOf(PropTypes.shape({}))
  };

  static defaultProps = {
    formErrors: [],
    onFileDeleteError: null,
    onFileDeleteSuccess: null,
    onFileUploadCancel: null,
    onFileUploadError: null,
    disableToasters: false,
    benefForms: []
  };

  constructor(props) {
    super(props);

    const fileSettings = getStorageSetting('files') || [];

    this.state = {
      fileSettings,
      benefFormType: null
    };
  }

  static getOwnerFormType(value) {
    const formType = FormTypes.getByValue(value);
    return (formType && formType.getFamilyName()) || value;
  }

  onBeneficiaryFormFileUploadCancel(file) {
    const { onFileUploadCancel } = this.props;

    if (onFileUploadCancel) {
      onFileUploadCancel(file);
    }
  }

  onBeneficiaryFormFileUploadError(file, error) {
    const { disableToasters, onFileUploadError } = this.props;

    if (onFileUploadError) {
      onFileUploadError(file, error);
    }

    if (!disableToasters) {
      toastr.error('', `${ file.name } failed.\n${ error && error.message }`);
    }
  }

  onBeneficiaryFormFileUploadSuccess(file, response) {
    const { disableToasters, onFileUploadSuccess } = this.props;

    if (onFileUploadSuccess) {
      onFileUploadSuccess(file, response);
    }

    if (!disableToasters) {
      toastr.success('', `${ response[0].fileName } has been uploaded`);
    }
  }

  onBeneficiaryFormTypeChange = (e, newValue) => this.setState({ benefFormType: newValue });

  onDeleteBeneficiaryForm(file) {
    const { disableToasters, onFileDeleteError, onFileDeleteSuccess } = this.props;
    ApiService
      .deleteTempUpload(file.id)
      .then((result) => {
        if (onFileDeleteSuccess) {
          onFileDeleteSuccess(file, result);
        }

        if (!result && !disableToasters) {
          toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
        }
      })
      .catch((err) => {
        if (onFileDeleteError) {
          onFileDeleteError(file, err);
        }

        if (!disableToasters) {
          toastr.error('', `Failed to remove ${ file.name }.  Please try again`);
        }
      });
  }

  onImyBeneficiarySelected = (e, value, index) => {
    const { onBeneficiarySelected } = this.props;

    if (onBeneficiarySelected) {
      onBeneficiarySelected(e, value, index);
    }
  };

  fieldHasErrors(field) {
    const { formErrors } = this.props;
    return formErrors != null && formErrors.filter(error => error.field === field).length > 0;
  }

  render() {
    const { benefForms, whdStatement } = this.props;
    const { benefFormType, fileSettings } = this.state;
    const hasUnassignedOwners = whdStatement && whdStatement.owners && whdStatement.owners.length > 0;
    const whdStatementOwnerOptions = hasUnassignedOwners && whdStatement.owners.map((item, ownerIndex) => <option
      value={ item.guid }
      key={ `${ item.name }-${ item.id || '' }` }
    >
      { ownerIndex + 1 } - { item.name }{ (item.formType > 0 && ` (${ BeneficialOwnerFormsUpload.getOwnerFormType(item.formType) })`) }{ (item.formId && ' (Pre-Existing)') }
    </option>);

    return <div className="form-group beneficial-owner-upload">
      { !hasUnassignedOwners && <div className="col-12 py-2"><div className="text-center my-2 py-2">
        All beneficial owner forms have been uploaded for the current tier
      </div></div> }
      { hasUnassignedOwners && <div className="col-12">
        <div className="form-group">
          <div className="col-2 col-sm-12">
            <label htmlFor="benef-form-type" className="form-label">Form Type</label>
          </div>
          <div className="col-10 col-sm-12">
            <FormTypeSelect
              id="benef-form-type"
              name="benefFormType"
              component={ SelectInput }
              className="form-select"
              value={ benefFormType }
              beneficiaryForms
              onChange={ (e, newValue) => this.onBeneficiaryFormTypeChange(e, newValue) }
            />
          </div>
        </div>
        <div className="form-group">
          <div className="col-12 col-sm-12 mb-2">
            { !benefFormType && <div className="filepicker disabled">
              <div className="dz-default dz-message">Please select the beneficiary form type above</div>
            </div> }
            { benefFormType && <FileUpload
              defaultMessage="Drop Beneficiary(ies) Forms here to upload in .pdf format"
              postUrl={ ApiService.getFileUploadUrl() }
              accessTokenName={ ApiService.getAccessTokenName() }
              acceptedFiles="application/pdf"
              maxFilesize={ fileSettings.maxFilesize }
              timeout={ fileSettings.uploadTimeout }
              docCategory="form"
              docType={ benefFormType != null ? benefFormType : '' }
              removeFileAfterUpload
              onFileUploadCancel={ file => this.onBeneficiaryFormFileUploadCancel(file) }
              onFileUploadSuccess={ (file, response) => this.onBeneficiaryFormFileUploadSuccess(file, response) }
              onFileUploadError={ (file, error) => this.onBeneficiaryFormFileUploadError(file, error) }
            /> }
          </div>
        </div>
        <div className="form-group">
          <div className="col-12">
            <table className="table table-striped table-hover table-data-side-bordered table-left-align">
              <thead>
                <tr>
                  <th>BO Forms</th>
                  <th colSpan="2">Beneficiary</th>
                </tr>
              </thead>
              <tbody>
                { benefForms != null && benefForms.length > 0 && benefForms.map((doc, index) => doc != null && <tr key={ doc.id }>
                  <td className="col-5">{ `${ doc.fileName }` }<br /><span className="sub-item">(Form type: { doc.typeDescription })</span></td>
                  <td>
                    <select
                      id={ `imy-beneficiary-id-${ index }` }
                      name={ `imyBeneficiaryAccount-${ index }` }
                      className={ `form-select ${ this.fieldHasErrors(`imyBeneficiaryAccount-${ index }`) ? 'is-error' : '' }` }
                      onChange={ e => this.onImyBeneficiarySelected(e, e.target.value, index) }
                    >
                      <option value="">Please select</option>
                      { whdStatementOwnerOptions }
                    </select>
                  </td>
                  <td>
                    <button
                      className="btn btn-sm btn-danger"
                      type="button"
                      title="Delete document"
                      onClick={ () => this.onDeleteBeneficiaryForm(doc) }
                    >
                      <span className="icon icon-delete" />
                    </button>
                  </td>
                </tr>)}
                { (benefForms == null || benefForms.length === 0) && <tr className="no-rows"><td colSpan="4">
                  No forms uploaded
                </td></tr> }
              </tbody>
            </table>
          </div>
        </div>
      </div> }
    </div>;
  }
}

export default BeneficialOwnerFormsUpload;
